import React from 'react';

interface Props {
  fillColor?: string;
}

export const ToiletIcon = ({ fillColor = '#ffc000' }: Props) => {
  return `data:image/svg+xml;base64,${btoa(`<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" width="256px" height="256px" fill="${fillColor}" stroke="${fillColor}">
<g id="SVGRepo_bgCarrier" stroke-width="0"/>
<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
<g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:${fillColor};} </style> <g> <path class="st0" d="M73.41,512h233.41v-63.997c60.239-7.534,131.77-101.65,131.77-161.88H73.41V512z"/> <rect x="73.41" class="st0" width="128.002" height="267.289"/> <path class="st0" d="M413.848,222.118H222.744v45.17H438.59v-20.438C438.59,233.198,427.51,222.118,413.848,222.118z"/> </g> </g>
</svg>`)}`;
};
